<script setup>
import AssetFilters from '../../components/forms/filters/events/Asset';
import AssetsTable from '../../components/table/events/Assets';
</script>

<template>
  <div data-view="assets">
    <!-- route to popup [[src/components/dialog/events/Asset.vue]] -->
    <!-- All popups will appear here -->
    <router-view />

    <layout-logged-frame :title="$t('event_assets')">
      <template v-slot:header-actions>
        <v-btn
          color="primary"
          @click="openNewEventAssetsModal"
        >
          <v-icon> add </v-icon>
          {{ $t('new_event_assets') }}
        </v-btn>
      </template>

      <template v-slot:content>
        <AssetFilters
          @filter="onFilter"
          @clearFilters="onClearFilters"
        />

        <AssetsTable
          :items="assets"
          :pagination="pagination"
          :is-loading="isLoading"
          :pages="totalPages"
          :on-select-item="selectItem"
          :on-update-pagination="onUpdatePagination"
          :on-change-page="onChangePage"
        />
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
import { isStr } from '@/utils';

export default {
  data() {
    return {
      pagination: {
        order: 'desc' ,
        page: 1,
        rowsPerPage: 15,
        perPage: 15,
        sortBy: 'created_at',
        totalItems: 0,
        search: '',
      },
      totalPages: 0,
      query: {
        per_page: 15,
      },
      isLoading: false,
    };
  },
  computed: {
    assets() {
      return this.$store.getters['events/assets'];
    },
    currentRoute() {
      return this.$route;
    },
  },
  methods: {
    openNewEventAssetsModal() {
      this.$router.push({ name: 'event-assets-new' });
    },
    getAssets() {
      this.isLoading = true;
      this.pagination.order = this.query.order;

      return this.$store
        .dispatch('events/getAssets', this.query)
        .then((res) => {
          const { total, current_page, last_page } = res.assetsMeta;

          this.pagination.page = current_page;
          this.pagination.lastPage = last_page;
          this.pagination.totalItems = total;
          this.totalPages = last_page;
          this.isLoading = false;

          return res;
        })
        .catch((err) => {
          this.isLoading = false;
          return err;
        });
    },
    selectItem(asset) {
      this.$store.dispatch('events/setActiveAsset', asset).then(() => {
        this.$router.push({name: 'event-assets-details', params: {id: asset.id}});
      });
    },
    onUpdatePagination({ page, order, sortBy }) {
      const { query, pagination } = this;
      this.pagination.order = order;
      this.pagination.sortBy = isStr(sortBy) ? sortBy : pagination.sortBy;

      const nextQuery = {
        ...query,
        page,
        order,
        sort: isStr(sortBy) ? sortBy : pagination.sortBy,
      };

      this.query = nextQuery;
      this.getAssets();
    },
    onChangePage(page) {
      const { query, pagination } = this;
      const { order, sortBy } = pagination;
      const nextQuery = {
        ...query,
        page,
        order,
        sort: sortBy,
      };

      this.query = nextQuery;
      this.getAssets();
    },
    onFilter(filters) {
      this.query = {
        ...this.query,
        page: 1,
        ...filters
      };

      this.getAssets();
    },
    onClearFilters() {
      const { sortBy } = this.pagination;
      this.query = { sort: sortBy };
      this.getAssets();
    },
  },
  watch: {
    currentRoute (to, from){
      if (
        (from.name === 'event-assets-new' ||
          from.name === 'event-assets-details') &&
        to.name === 'event-assets' &&
        to.query?.status === 'success'
      ) {
        this.isLoading = true;
        this.getAssets();
      }
    }
  },
};
</script>

<style lang="scss">
@use '../../assets/styles/theme' as *;

[data-view='assets'] {
  .trigger.download-pdf {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .v-icon {
      margin: 0 6px 0 0;
    }
  }

  .v-datatable {
    min-width: $table-min-width;
  }
}
</style>
